import { Lock } from 'lucide-react'
import { PERMISSIONS } from '@/lib/permissions'
import { GroupActionList } from './GroupActionList'
import { GROUP_OPS_STR as S, setGroupRestricted } from './groupOpsApi'

/**
 * A4.24 — Cheklov qo'yish. Chatni faqat-o'qish rejimiga o'tkazadi (yozishni
 * to'xtatadi). JONLI `/admin/groups` ro'yxati; mutatsiya endpoint chiqqach jonli.
 */
export function GroupRestrict() {
  return (
    <GroupActionList
      screenId="A4.24"
      title={S.restrict}
      description={S.restrictNote}
      actionId="restrict"
      actionLabel={S.restrict}
      actionIcon={<Lock size={13} />}
      emptyIcon={<Lock size={28} strokeWidth={1.5} />}
      permission={PERMISSIONS.USERS_BAN}
      danger
      successMsg={S.restricted}
      run={async (r) => {
        const reason = (window.prompt(S.restrictReason) ?? '').trim()
        if (!window.confirm(S.restrictConfirm)) return false
        await setGroupRestricted(r.id, true, reason)
        return true
      }}
    />
  )
}
